export default __webpack_public_path__ + "static/media/Green-phone.10d2b630.svg";